<template>
	<div>
		<iframe class="external-frame" src="https://www.google.com/maps/d/embed?mid=10weOSn5uyOssdAuwfCRD3BrfTJ8&ehbc=2E312F" width="100%" height="480"></iframe>
	</div>
</template>

<script>
import transport from '@/config/api/api_events/transport.js';
import map_helper from '@/config/js_helper/map_helper.js';
export default {
	name: 'Playgrounds',
	mounted() {
		this.$store.state.active_loader = false;
	},
};
</script>

<style scoped lang="scss" src="./AllPlayground.scss"></style>
